<script setup>
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  plan: { type: Object, required: true },
});

const emit = defineEmits(['edit']);
const { t } = useI18n();
</script>

<template>
  <LaisCard
    :title="t('REAL_ESTATE_COMMISSION_PLAN.SUMMARY.PAYMENT')"
    prefix-icon="i-lucide-wallet-cards"
  >
    <dl class="grid gap-4 text-sm">
      <div class="flex items-center justify-between gap-3">
        <dt class="text-lais-text-muted">
          {{ t('REAL_ESTATE_COMMISSION_PLAN.FIELDS.METHOD') }}
        </dt>
        <dd class="font-semibold text-lais-text">
          {{
            plan.forma_pagamento ||
            t('REAL_ESTATE_COMMISSION_PLAN.COMMON.NOT_INFORMED')
          }}
        </dd>
      </div>
      <div class="flex items-center justify-between gap-3">
        <dt class="text-lais-text-muted">
          {{ t('REAL_ESTATE_COMMISSION_PLAN.FIELDS.TYPE') }}
        </dt>
        <dd class="flex flex-wrap justify-end gap-2">
          <span
            class="rounded-full bg-lais-primary-50 px-2 py-1 text-xs font-bold text-lais-primary"
          >
            {{ plan.tipo_pagamento }}
          </span>
          <span
            v-if="plan.tipo_pagamento === 'Parcelada'"
            class="rounded-full bg-lais-primary-50 px-2 py-1 text-xs font-bold text-lais-primary"
          >
            {{
              t('REAL_ESTATE_COMMISSION_PLAN.SUMMARY.INSTALLMENT_COUNT', {
                count: plan.parcelas_empresa?.length || 0,
              })
            }}
          </span>
        </dd>
      </div>
    </dl>
    <template #footer>
      <LaisPrimaryButton
        variant="ghost"
        icon="i-lucide-pencil"
        @click="emit('edit')"
      >
        {{ t('REAL_ESTATE_COMMISSION_PLAN.ACTIONS.EDIT') }}
      </LaisPrimaryButton>
    </template>
  </LaisCard>
</template>
